"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetProfileState = exports.changePassword = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const react_native_1 = require("react-native");
const constants_1 = require("../../constants/constants");
const typesConstants_1 = require("../../constants/typesConstants");
const network_1 = require("../../utils/network");
const profileConstants_1 = __importDefault(require("./profileConstants"));
const initialState = {
    change_password: { status: typesConstants_1.IDLE_STATUS, errorMessage: undefined },
};
exports.changePassword = toolkit_1.createAsyncThunk('profile/change_password', async ({ current_password, new_password, repeat_new_password }, { getState, rejectWithValue }) => {
    try {
        const body = {
            current_password,
            new_password,
            repeat_new_password,
        };
        const { auth } = getState();
        return await network_1.post(profileConstants_1.default, auth.token, body)
            .then(network_1.checkHttpStatus)
            .then(network_1.parseJSON);
    }
    catch (err) {
        if (err.message === constants_1.DEFAULT_NETWORK_ERROR_MESSAGE) {
            react_native_1.Alert.alert('Network Error', 'Unable to connect to server.\nPlease check your internet connection.');
            throw new Error(err);
        }
        return rejectWithValue(err);
    }
});
const profileSlice = toolkit_1.createSlice({
    name: 'profile',
    initialState,
    reducers: {
        resetProfileState() {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(exports.changePassword.pending, (state) => ({
            ...state,
            status: typesConstants_1.PENDING_STATUS,
        }))
            .addCase(exports.changePassword.rejected, (state, { payload }) => ({
            ...state,
            change_password: {
                status: typesConstants_1.FAILED_STATUS,
                errorMessage: payload.message,
                errors: payload.errorObject,
            },
        }))
            .addCase(exports.changePassword.fulfilled, (state) => ({
            ...state,
            change_password: {
                status: typesConstants_1.SUCCEEDED_STATUS,
                errorMessage: undefined,
                errors: undefined,
            },
        }));
    },
});
exports.resetProfileState = profileSlice.actions.resetProfileState;
exports.default = profileSlice.reducer;
